import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useState } from "react";
import { useFragment } from "react-relay";

import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner";
import { MarkdownDisplay } from "@whoosh/design-system/src/components/display/MarkdownDisplay/MarkdownDisplay";
import { PopUpModal } from "@whoosh/design-system/src/components/overlay/PopUpModal";
import { VStack } from "@whoosh/design-system/src/components/primitive";

import { MemberNote_Booking$key } from "./__generated__/MemberNote_Booking.graphql";

type Props = {
  bookingRef: MemberNote_Booking$key | null;
};

export const MemberNote = ({ bookingRef }: Props) => {
  const data = useFragment(MemberNoteFragmentString, bookingRef);
  const status = data?.startSlot?.agenda?.memberNote?.status;
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      {data?.startSlot?.agenda?.memberNote?.header ? (
        <InfoBanner
          message={t`${data?.startSlot?.agenda?.memberNote?.header || ""}`}
          colorTheme={
            status === "HIGH"
              ? "ERROR"
              : status === "MEDIUM"
              ? "WARNING"
              : "NEUTRAL"
          }
          action={{
            label: t`Read More`,
            handler: () => setIsModalOpen(true),
          }}
        />
      ) : null}

      <PopUpModal
        isOpen={isModalOpen}
        cancelText={t`Dismiss`}
        isConfirmVisible={false}
        onClose={() => {
          setIsModalOpen(false);
        }}
        content={
          <VStack>
            {data?.startSlot?.agenda?.memberNote?.body ? (
              <MarkdownDisplay
                markdown={data.startSlot.agenda.memberNote.body}
              />
            ) : null}
          </VStack>
        }
      />
    </>
  );
};

const MemberNoteFragmentString = graphql`
  fragment MemberNote_Booking on Booking {
    startSlot {
      agenda {
        memberNote {
          header
          body
          status
        }
      }
    }
  }
`;
